(function() {
  function clearFranchiser() {
    try {
      localStorage.removeItem('franchiser');
    } catch(e) {
      console.warn('Could not clear franchiser', e);
    }
    var url = new URL(window.location.href);
    url.searchParams.delete('franchiser');
    history.replaceState({}, '', url.toString());
  }

  function persistFranchiserInUrl(code) {
    if (!code) return;
    var url = new URL(window.location.href);
    if (url.searchParams.get('franchiser') !== code) {
      url.searchParams.set('franchiser', code);
      history.replaceState({}, '', url.toString());
    }
  }

  function setFranchiser() {
    // Case: if URL has "thank_you" → clear immediately
    if (window.location.href.includes('thank_you')) {
      clearFranchiser();
      return;
    }

    var params = new URLSearchParams(window.location.search);
    var franchiser = params.get('franchiser');

    if (franchiser) {
      franchiser = decodeURIComponent(franchiser);
      try {
        localStorage.setItem('franchiser', franchiser);
      } catch(e) {
        console.warn('Could not save franchiser', e);
      }
      persistFranchiserInUrl(franchiser);

      // Sync with cart if needed
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          var current = (cart.attributes && cart.attributes.franchiser) || null;
          if (current !== franchiser) {
            fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ attributes: { franchiser } })
            }).catch(err => console.error('Failed to update cart attribute', err));
          }
        })
        .catch(err => console.error('Error fetching cart', err));

    } else {
      // Fresh direct visit (typed domain)
      if (document.referrer === '' && performance.navigation.type === 0) {
        clearFranchiser();
      } else {
        // Restore from storage if missing in URL
        var saved = localStorage.getItem('franchiser');
        if (saved) persistFranchiserInUrl(saved);
      }
    }
  }

  // Run once
  setFranchiser();

  // Re-run on navigation
  var pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    setTimeout(setFranchiser, 200);
  };
  window.addEventListener('popstate', setFranchiser);

  // Re-run on DOM mutations
  var observer = new MutationObserver(setFranchiser);
  observer.observe(document, { childList: true, subtree: true });
})();